import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderRoutingModule } from './header-routing.module';
import { HeaderComponent } from './header.component';
import { DialogRegistrationsClosedComponent } from './dialog-registrations-closed/dialog-registrations-closed.component';
import { ShareModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    HeaderComponent,
    DialogRegistrationsClosedComponent
  ],
  imports: [
    CommonModule,
    HeaderRoutingModule,
    ShareModule
  ],
  exports : [HeaderComponent]
})
export class HeaderModule { }
